<template lang="pug">
  nav(v-if="items && items.length")
    TreeMenu(
      :items="items"
      :max-depth="maxDepth"
      :delay="400"
      :active-ids="activeMenuItemIDs"
      :toggle-event="toggleEvent"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import { get, cloneDeep } from '@/helpers';

import NestedSet from '@/nested-set-lib';

export default {
  name: 'Menu',
  props: {
    k: {
      type: String,
      required: true
    },
    maxDepth: {
      type: Number,
      default: 2
    },
    toggleEvent: {
      type: String,
      default: 'hover'
    }
  },
  computed: {
    items() {
      const menu = this.menus.find(menu => menu.key === this.k);
      let items = get(menu, 'menuItems') || [];
      items = cloneDeep(items);

      if (items.length) {
        return NestedSet.createTree(items);
      }

      return items;
    },
    activeMenuItemIDs() {
      let IDs = [];

      const menus = this.menus || [];
      const menu = menus.find(menu => menu.key === this.k);
      const items = get(menu, 'menuItems') || [];

      let item;
      if (this.$route.name === 'product-details') {
        let path = '/';

        // NOTE: can not get from SetupAPI .. apollo error
        const history = JSON.parse(window.sessionStorage.getItem('history')) || [];
        if (history.length) {
          history.forEach(path => {
            if (item) return;
            item = items.find(el => el.path === path);
          });
        } else {
          item = items.find(el => el.path === path);
        }
      } else {
        const path = this.$route.path;
        item = items.find(el => el.path === path);
      }

      if (item) {
        const ancestors = NestedSet.getAncestors(cloneDeep(items), item);
        IDs = [...ancestors, item].map(el => el.id);
      }

      const matched = this.$route.matched;
      matched.forEach(el => {
        const path = el.path;
        item = items.find(el => el.path === path);

        if (item) {
          const ancestors = NestedSet.getAncestors(cloneDeep(items), item);
          IDs = [...IDs, ...[...ancestors, item].map(el => el.id)];
        }
      });

      return IDs;
    },
    ...mapGetters({
      menus: 'menus'
    })
  }
};
</script>
